import { getAgencySession, subscribeAgencySession } from "../../../utils/agencySession.ts";
import type { AccountOrderDraft } from "./accountOrderService.ts";

const prefix = "account-order-edit:";
const lifetime = 24 * 60 * 60 * 1000;
type Recovery = { version: string; draft: AccountOrderDraft; expires: number };

export function orderRecoveryKey(orderId: string): string {
  const session = getAgencySession();
  return `${prefix}${window.location.host}:${session?.userId}:${session?.salesAgencyId}:${session?.membershipId}:${orderId}`;
}

export function readOrderRecovery(key: string): Recovery | undefined {
  try {
    const value = sessionStorage.getItem(key);
    if (!value) return undefined;
    const saved: Recovery = JSON.parse(value);
    if (saved.expires > Date.now() && typeof saved.version === "string" && Array.isArray(saved.draft?.items)) return saved;
    sessionStorage.removeItem(key);
  } catch { /* Unavailable storage does not prevent reading the server order. */ }
  return undefined;
}

export function retainOrderRecovery(key: string, version: string, draft: AccountOrderDraft): void {
  sessionStorage.setItem(key, JSON.stringify({ version, draft, expires: Date.now() + lifetime }));
}

export function clearOrderRecovery(key: string): void {
  try { sessionStorage.removeItem(key); } catch { /* A confirmed server save remains authoritative. */ }
}

export function orderDraftSignature(draft: AccountOrderDraft): string {
  return JSON.stringify([draft.salesAgencyId ?? null, draft.title?.trim() || "", draft.description || "",
    draft.items.map(function (line) { return [line.productVariantId, line.quantity]; }).sort(function (a, b) { return a[0] - b[0]; })]);
}

subscribeAgencySession(function () {
  // Do not retain private drafts across logout or agency/account switching.
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith(prefix) && (!getAgencySession() || !key.startsWith(orderRecoveryKey("")))) {
        sessionStorage.removeItem(key);
      }
    }
  } catch { /* Storage may be disabled by the browser. */ }
});
